var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-grid',{staticClass:"grid-mask mask",attrs:{"cols":_vm.cols.length}},_vm._l((_vm.cols),function(c,i){return _c('v-grid-cell',{key:i,staticClass:"grid-mask__cell",style:({ backgroundColor: c.color })})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }